import { formatarNumero, SEM_VALOR } from '@/design/formato';

/* Como o laudo escreve número e sinal. Três decisões que apareciam em cinco
 * blocos diferentes do documento e precisam responder igual em todos. */

/**
 * Volume de projetos. Inteiro sai inteiro ("18"), fracionado sai com uma casa
 * ("18,4"): projeção de sazonalidade parcial quase nunca dá número redondo, e
 * arredondar aqui esconderia a diferença entre 18 e 18,4 na coluna de volume
 * necessário.
 */
export function formatarVolume(valor: number | null): string {
  if (valor === null || !Number.isFinite(valor)) return SEM_VALOR;
  return Number.isInteger(valor)
    ? formatarNumero(valor, { casasMax: 0 })
    : formatarNumero(valor, { casasMin: 1, casasMax: 1 });
}

/** Rótulo curto de eixo. Mesma unidade do texto corrido: "mil" e "mi", nunca "K". */
export function abreviarReais(valor: number): string {
  const absoluto = Math.abs(valor);
  if (absoluto >= 1e6) return `${formatarNumero(valor / 1e6, { casasMin: 1, casasMax: 1 })} mi`;
  if (absoluto >= 1e3) return `${formatarNumero(valor / 1e3, { casasMax: 0 })} mil`;
  return formatarNumero(valor, { casasMax: 0 });
}

/** Ausência de dado é neutra, nunca vermelha: "—" não é prejuízo. */
export function tomDoLucro(valor: number | null): 'neutro' | 'positivo' | 'negativo' {
  if (valor === null) return 'neutro';
  return valor < 0 ? 'negativo' : 'positivo';
}
